// extracted by mini-css-extract-plugin
export var active = "_uj-1";
export var circle = "_uj-0";
export var completed = "_uj-2";
export var connector = "_uj-4";
export var connectorCompleted = "_uj-7";
export var connectorSpacer = "_uj-5";
export var iconStrokeOverride = "_uj-8";
export var labelContainer = "_uj-6";
export var pending = "_uj-3";